import CustomCheckbox from "../CustomCheckbox";
import { showGrade } from "../../utils/textUtils";

const FilterPanel = ({
  gradeOptions,
  levelOptions,
  gradeList,
  levelList,
  setGradeList,
  setLevelList,
}) => {
  const toggleGrade = (grade) => {
    setGradeList((prev) => {
      return prev.includes(grade)
        ? prev.filter((g) => g !== grade)
        : [...prev, grade];
    });
  };

  const toggleLevel = (level) => {
    setLevelList((prev) => {
      return prev.some((l) => l.id === level.id)
        ? prev.filter((l) => l.id !== level.id)
        : [...prev, level];
    });
  };

  // 학년 전체 선택/해제
  const handleGradeSelectAll = (isSelected) => {
    setGradeList(isSelected ? [...gradeOptions] : []);
  };

  // 클래스 전체 선택/해제
  const handleLevelSelectAll = (isSelected) => {
    setLevelList(isSelected ? [...levelOptions] : []);
  };

  return (
    <div
      style={{
        borderRight: "1px solid #EBEBEB",
        color: "#2D2D2D",
        padding: "10px",
      }}
    >
      {/* Grade 리스트 */}
      <div>
        <h3 style={{ marginBottom: "10px", marginTop: "0px" }}>학년</h3>
        {/* 전체 선택/해제 체크박스 */}
        <div style={{ marginBottom: "6px" }}>
          <CustomCheckbox
            checked={gradeList.length === gradeOptions.length}
            indeterminate={
              gradeList.length > 0 && gradeList.length < gradeOptions.length
            }
            onChange={(e) => handleGradeSelectAll(e.target.checked)}
          />
          <span style={{ marginLeft: "8px", fontSize: "18px" }}>
            학년 전체 선택
          </span>
        </div>
        {gradeOptions.map((grade) => (
          <div key={grade} style={{ marginBottom: "6px" }}>
            <CustomCheckbox
              checked={gradeList.includes(grade)}
              onChange={() => toggleGrade(grade)}
            />
            <span style={{ marginLeft: "8px", fontSize: "18px" }}>
              {showGrade(grade)}
            </span>
          </div>
        ))}
      </div>

      {/* Level 리스트 */}
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ margin: "10px 0" }}>클래스</h3>
        {/* 전체 선택/해제 체크박스 */}
        <div style={{ marginBottom: "6px" }}>
          <CustomCheckbox
            checked={levelList.length === levelOptions.length}
            indeterminate={
              levelList.length > 0 && levelList.length < levelOptions.length
            }
            onChange={(e) => handleLevelSelectAll(e.target.checked)}
          />
          <span style={{ marginLeft: "8px", fontSize: "18px" }}>
            클래스 전체 선택
          </span>
        </div>
        {levelOptions.map((level) => (
          <div key={level.id} style={{ marginBottom: "6px" }}>
            <CustomCheckbox
              checked={levelList.some((l) => l.id === level.id)}
              onChange={() => toggleLevel(level)}
            />
            <span style={{ marginLeft: "8px", fontSize: "18px" }}>
              {level.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterPanel;
